
import React from "react";
import { Button } from "@/components/ui/button";
import { Building } from "lucide-react";

interface ClaimButtonProps {
  onClick: () => void;
}

export function ClaimButton({ onClick }: ClaimButtonProps) {
  return (
    <div>
      <Button onClick={onClick} className="w-full bg-amber-50 text-amber-900 hover:bg-amber-100 border border-amber-200 mb-2">
        <Building className="h-4 w-4 mr-2" />
        Claim this profile
      </Button>
      <p className="text-xs text-muted-foreground">
        Only a verified representative can claim and update this nursing home's profile.
      </p>
    </div>
  );
}
